module.exports = __webpack_public_path__ + "img/zxlw_h.a394ed4e.png";